import React from 'react';

import { selectDeliveryPreference } from 'store/deliveryPreference';
import { useAppSelector } from 'store/store';

import { useCurrentArticle, useFirstArticle } from '../../hooks/shipment.hooks';
import { RECIPIENT_INSTRUCTIONS_TEST_ID, SENDER_INSTRUCTIONS_TEST_ID } from '../DetailsPanel.test-ids';
import InfoRow from '../InfoRow/InfoRow';
import recipientLine from './RecipientLine/RecipientLine';
import senderLine from './SenderLine/SenderLine';

import detailsPanelStyles from '../DetailsPanel.module.scss';
import styles from './DeliveryInstructions.module.scss';

const DeliveryInstructions: React.FC = () => {
  const atlEligible = useFirstArticle()?.atlEligible || false;
  const { address, safeDropIneligibility, articleId, atlStatus = null } = useCurrentArticle() || {};
  const deliveryPreferenceData = useAppSelector(selectDeliveryPreference);

  const intlOutbound = address?.internationalAddress || false;
  const safeDropIneligibilityCode = safeDropIneligibility?.code;
  const deliveryInstruction = deliveryPreferenceData?.instruction;

  const recipientInstruction = recipientLine(
    articleId,
    atlEligible,
    atlStatus,
    safeDropIneligibilityCode,
    deliveryInstruction
  );
  const senderInstruction = senderLine(atlEligible, intlOutbound, safeDropIneligibilityCode);

  if (!senderInstruction && !recipientInstruction) return null;

  return (
    <>
      <InfoRow heading='Delivery instructions'>
        {senderInstruction && (
          <span className={styles.textContent} data-testid={SENDER_INSTRUCTIONS_TEST_ID}>
            {senderInstruction}
          </span>
        )}
        {recipientInstruction && (
          <span className={styles.textContent} data-testid={RECIPIENT_INSTRUCTIONS_TEST_ID}>
            {recipientInstruction}
          </span>
        )}
      </InfoRow>
      <div className={detailsPanelStyles.divider} />
    </>
  );
};

export default DeliveryInstructions;
